/**
 * La mascota sencilla —borde y ojos— con la forma de un icono de Tabler, para
 * los sitios que reciben el COMPONENTE del icono y no el icono ya dibujado
 * (`icon: IconBolt` en las tarjetas de uso). Es el icono de la IA en todo el
 * panel; lo demás sigue con Tabler.
 */
import { forwardRef } from 'react'
import type { TablerIcon } from '@tabler/icons-react'
import { VelticaMascot } from '@webbuilder/ui'

export const MascotIcon = forwardRef<SVGSVGElement, { size?: number | string; className?: string }>(
  function MascotIcon({ size = 24, className }, _ref) {
    return <VelticaMascot outline size={Number(size) || 24} {...(className ? { className } : {})} />
  },
) as unknown as TablerIcon
